import { type ComponentProps, useCallback, useMemo } from 'react';

import { useGoals } from '@atlassian/global-shortcuts/goals';
import { useProjects } from '@atlassian/global-shortcuts/projects';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation/GlobalSideNavigation';

import { AnalyticsSideNavItem } from '@townsquare/analytics-nav4';
import { getConfig } from '@townsquare/config';
import { SideNavAppItem as SideNavAppItemID } from '@townsquare/navigation-config/nav4';
import { useOrgContextOrgId } from '@townsquare/org-context';
export const useSideNavAppItemsForNavPlatform = (): ComponentProps<
	typeof GlobalSideNavigation
>['shortcuts'] => {
	const config = getConfig();
	const orgId = useOrgContextOrgId();

	const goalsItem = useGoals(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/goals` : `${config.fullUrl}/o/${orgId}/goals`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.GOALS },
	);

	const projectsItem = useProjects(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/projects` : `${config.fullUrl}/o/${orgId}/projects`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.PROJECTS },
	);

	return useMemo(
		() => ({
			[SideNavAppItemID.GOALS_APP]: {
				...goalsItem,
				analyticsName: AnalyticsSideNavItem.GOALS,
			},
			[SideNavAppItemID.PROJECTS_APP]: projectsItem,
		}),
		[goalsItem, projectsItem],
	);
};
